<div
    *ngIf="!showData"
    class="
        placeholder-text
        container-fluid
        d-flex
        align-items-center
        justify-content-center
        h-100
    "
>
    <p>{{ 'evaluation.SL.media.noDataMessage' | translate }}</p>
</div>
<div class="labeling-central-tile">
    <div class="current-image">
        <div #panzoomParent class="current-image-inner">
            <ngx-panzoom
                #PanZoom
                [zoomLevels]="panZoomConfig.zoomLevels"
                [initialZoomLevel]="panZoomConfig.neutralZoomLevel"
                [scalePerZoomLevel]="panZoomConfig.scalePerZoomLevel"
                [neutralZoomLevel]="panZoomConfig.neutralZoomLevel"
                [zoomOnMouseWheel]="panZoomConfig.zoomOnMouseWheel"
                [zoomOnDoubleClick]="panZoomConfig.zoomOnDoubleClick"
                [invertMouseWheel]="panZoomConfig.invertMouseWheel"
                [freeMouseWheel]="panZoomConfig.freeMouseWheel"
                [dragMouseButton]="panZoomConfig.dragMouseButton"
                (modelChange)="onModelChanged($event)"
                [zoomToFitZoomLevelFactor]="panZoomConfig.zoomToFitZoomLevelFactor"
            >
                <img
                    #currentImage
                    (load)="onImageLoad()"
                    [src]="selectedImage?.url"
                    [alt]="selectedImage?.id"
                    *ngIf="showData"
                />
                <svg
                    *ngIf="svgStatus && showData"
                    [ngStyle]="{
                        cursor: cursorView
                    }"
                    (mousedown)="cursorView = 'grabbing'"
                    (mouseup)="cursorView = 'grab'"
                    id="labeling"
                    #labeling
                    [attr.width]="svgStatus.w"
                    [attr.height]="svgStatus.h"
                    [attr.viewBox]="svgStatus.viewBox"
                    preserveAspectRatio="xMidYMid meet"
                >
                    <g
                        *ngFor="let annotation of annotations"
                        class="annotation-box"
                        [ngClass]="
                            isVisualEvalAnnotation(annotation)
                                ? 'model-annotation'
                                : 'ground-truth-annotation'
                        "
                    >
                        <rect
                            class="bounding-box"
                            [ngStyle]="{
                                stroke: getColorByAnnotation(annotation),
                                fill: getColorByAnnotation(annotation, true)
                            }"
                            [attr.x]="annotation.bbox.x"
                            [attr.y]="annotation.bbox.y"
                            [attr.width]="annotation.bbox.width"
                            [attr.height]="annotation.bbox.height"
                        ></rect>
                        <g
                            class="title-group"
                            *ngIf="
                                (isVisualEvalAnnotation(annotation) &&
                                    showNames.showPostTrainName) ||
                                (!isVisualEvalAnnotation(annotation) &&
                                    showNames.showPreTrainName)
                            "
                        >
                            <rect
                                class="title-box"
                                [ngStyle]="{
                                    fill: getColorByAnnotation(annotation)
                                }"
                                [attr.x]="annotation.bbox.x"
                                [attr.y]="
                                    isVisualEvalAnnotation(annotation)
                                        ? annotation.bbox.height +
                                          annotation.bbox.y
                                        : annotation.bbox.y - titleBoxHeight
                                "
                                [attr.width]="annotation.bbox.width"
                                [attr.height]="titleBoxHeight"
                            ></rect>
                            <!-- Top/Bottom border -->
                            <line
                                [ngStyle]="{
                                    stroke: getColorByAnnotation(annotation)
                                }"
                                [attr.x1]="annotation.bbox.x"
                                [attr.x2]="
                                    annotation.bbox.x + annotation.bbox.width
                                "
                                [attr.y1]="getLineYCoordinate(annotation)"
                                [attr.y2]="getLineYCoordinate(annotation)"
                            ></line>

                            <!-- Left border -->
                            <line
                                [ngStyle]="{
                                    stroke: getColorByAnnotation(annotation)
                                }"
                                [attr.x1]="annotation.bbox.x"
                                [attr.x2]="annotation.bbox.x"
                                [attr.y1]="
                                    getLineYCoordinate(annotation, false)
                                "
                                [attr.y2]="getLineYCoordinate(annotation)"
                            ></line>

                            <!-- Right border -->
                            <line
                                [ngStyle]="{
                                    stroke: getColorByAnnotation(annotation)
                                }"
                                [attr.x1]="
                                    annotation.bbox.x + annotation.bbox.width
                                "
                                [attr.x2]="
                                    annotation.bbox.x + annotation.bbox.width
                                "
                                [attr.y1]="
                                    getLineYCoordinate(annotation, false)
                                "
                                [attr.y2]="getLineYCoordinate(annotation)"
                            ></line>
                            <!-- label name -->
                            <!-- Text alignment calculation based on font-size + (titleBoxHeight - font-size) / 2 - border-width -->
                            <text
                                [attr.x]="annotation.bbox.x + 5"
                                [attr.y]="
                                    isVisualEvalAnnotation(annotation)
                                        ? annotation.bbox.height +
                                          annotation.bbox.y +
                                          19
                                        : annotation.bbox.y - 11
                                "
                                class="title"
                            >{{ getImgCategoryName(annotation.categoryId) }}</text>
                        </g>
                    </g>
                </svg>
            </ngx-panzoom>
        </div>
    </div>
    <div class="zoom-and-paging-footer">
        <div
            class="paging-container d-flex justify-content-center"
            *ngIf="images.length"
        >
            <app-input-paging-bar
                tag="annotate"
                [maxValue]="totalElements"
                [currentValue]="currentImageNumber"
                (nextValue)="onNextValue($event)"
            ></app-input-paging-bar>
        </div>
        <div
            class="zoom-control-group"
            [ngClass]="{
                'zoom-out-disabled': currentZoomLevel === panZoomConfig.minZoomLevel,
                'zoom-in-disabled': currentZoomLevel === panZoomConfig.zoomLevels
            }"
        >
            <div class="zoom-control" (click)="onZoomOut()" id="zoom-out">
                <p>-</p>
            </div>
            <input
                [formControl]="zoomControl"
                type="range"
                class="indicator"
                [min]="panZoomConfig.minZoomLevel"
                [max]="panZoomConfig.zoomLevels"
                (change)="onSliderZoomChange()"
            />
            <div class="zoom-control" (click)="onZoomIn()" id="zoom-in">
                <p>+</p>
            </div>
        </div>
    </div>
</div>
